(function () {
  function openRiseQuickView(button) {
    var host = button.closest('product-card');
    if (!host) return false;

    var chooseBtn = host.querySelector('.quick-add__button--choose');
    if (chooseBtn) {
      chooseBtn.click();
      return true;
    }

    var link = host.querySelector('[ref="productCardLink"]');
    if (link && link.href) {
      window.location.href = link.href;
      return true;
    }

    return false;
  }

  function onClick(event) {
    var button = event.target.closest('[data-rise-quick-view]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    openRiseQuickView(button);
  }

  document.addEventListener('click', onClick);
})();
